import React from "react";
import ReactDOM from "react-dom";
import App from "./app";

const rootElement = document.getElementById("configurator-root");
const version = rootElement?.dataset.version || "v1";
const accessories = rootElement?.dataset.accessories === "true";

if (rootElement) {
    const basename = rootElement.dataset.basename.replace(/\/$/, "");
    ReactDOM.render(
        <App basename={basename} version={version} accessories={accessories} />,
        rootElement
    );
}
